import { useState } from "react";
import { ResponseGetAllBasesResponse, BasesApi } from "../../services/OpenAPI";
import { createConfiguration } from "./common";

export const useApiGetBaseSearchOptions = () => {
  const [baseSearchOptions, setBaseSearchOptions] = useState<
    ResponseGetAllBasesResponse[] | null
  >([]);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchBaseSearchOptions = async () => {
    setIsLoading(true);
    setError(null);

    try {
      const config = createConfiguration();

      const api = new BasesApi(config);
      const response = await api.basesGetAllGet();
      setBaseSearchOptions(response);
      return response;
    } catch (err) {
      setError("拠点検索バーの取得に失敗しました");
      console.error(err);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return { baseSearchOptions, fetchBaseSearchOptions, error, isLoading };
};
